import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

//components
import $FadingOverflow from 'components/FadingOverflow';
import {getFormattedTextStyle} from 'styles/formatted-text';

const toolbarHeight = '3rem';

export const ToolContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${toolbarHeight};
  overflow: hidden;
`;

export const StyledFadingOverflow = styled($FadingOverflow)`
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: 2rem;
  max-height: calc(100% - 1rem);
`;

export const Content = styled.div`
  padding: 1.5rem 2rem;
  word-wrap: break-word;

  p {
    line-height: 1.5rem;
    margin: 0 0 1.5rem 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    font-weight: bold;
  }

  ${getFormattedTextStyle(true)}
`;

export const ToolbarWrapper = styled.div`
  .example-enter {
    .fader {
      opacity: 0;
    }
    .content {
      bottom: -40px;
    }
  }

  .example-enter.example-enter-active {
    .fader {
      opacity: 1;
      transition: 150ms;
    }
    .content {
      bottom: 0;
      transition: 150ms;
    }
  }

  .example-leave {
    .fader {
      opacity: 1;
      transition: 150ms;
    }
    .content {
      opacity: 1;
      bottom: 0px;
    }
  }

  .example-leave.example-leave-active {
    .fader {
      opacity: 0;
      transition: 150ms;
    }
    .content {
      opacity: 0;
      bottom: -40px;
      transition: 150ms;
    }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  height: ${toolbarHeight};
  > div {
    flex: 1;
    min-width: 0px;
  }
`;

export const Fader = styled.div`
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const StyledNoteHeader = styled.div`
  background: ${commonPalette.orange};
  color: white;
  padding: 0.25rem 2rem;
  font-size: 0.7rem;
`;
